import React, { useState, useEffect, Fragment } from 'react';

import { ResultProvider } from '../../dataProvider/results';
import { getResultOrigin } from '../../dataProvider/origin';
import { TYPES, SUBTYPES, EXCLUDED_REGIONS } from '../../envs/core';
import './multiPactometroA3.scss';
import PactometroCheck from '../../components/pactometroCheck';
import Button from '../../components/button';
import Autocomplete from './../../components/autocomplete';
import { PlacesProvider } from '../../dataProvider/places';
import { getData } from '../../dataProvider/places/single';

const MultiPactometroA3 = ({ match, history }) => {
  const { year, type, electionNumber, place, reload } = match.params;

  const [resultOrigin, setResultOrigin] = useState({});

  const [selectedType, setSelectedType] = useState(type);

  const [autocomple, setAutocomple] = useState('');
  const [selectedChecks, setSelectedChecks] = useState([]);

  const [selectedPlace, setSelectedPlace] = useState('');

  const changeSelection = town => {
    setSelectedChecks([]);

    history.push(
      `/${reload}/${year}/${selectedType}/${electionNumber}/${town.ineId}/multipactometroA3.html`
    );
  };

  useEffect(() => {
    setSelectedType(type);
    getResultOrigin(
      year,
      type,
      electionNumber,
      type === TYPES.REGIONAL ? place : 'C108'
    )
      .then(historicResult => {
        setResultOrigin(historicResult);
      })
      .catch(err => {});

    getData(place).then(p => {
      setSelectedPlace(p);
    });
  }, [year, type, electionNumber, place]);

  const changeScope = scope => {
    setSelectedChecks([]);
    if (scope === TYPES.REGIONAL) {
      history.push(
        `/${reload}/${year}/${scope}/${electionNumber}/R13/multipactometroA3.html`
      );
    } else if (scope === TYPES.MUNICIPAL) {
      history.push(
        `/${reload}/${year}/${scope}/${electionNumber}/28079/multipactometroA3.html`
      );
    }
  };
  return (
    <div className="multiPactometroA3Page">
      {resultOrigin && resultOrigin.primary && (
        <Fragment>
          <ResultProvider
            active={resultOrigin.historic.active}
            year={resultOrigin.historic.year}
            type={selectedType}
            subtype={SUBTYPES.SINGLE}
            electionNumber={electionNumber}
            placeId={place}
            electionPlace={selectedType === TYPES.REGIONAL ? place : ''}
          >
            {oldData => (
              <Fragment>
                <ResultProvider
                  active={resultOrigin.primary.active}
                  year={year}
                  type={selectedType}
                  subtype={SUBTYPES.SINGLE}
                  electionNumber={electionNumber}
                  placeId={place}
                  electionPlace={selectedType === TYPES.REGIONAL ? place : ''}
                  details={selectedType === TYPES.MUNICIPAL}
                >
                  {dataResult => (
                    <div>
                      <Fragment>
                        <div className="buttons">
                          <h2 className="mainTitle">
                            {window.location.hostname.includes('ondacero')
                              ? 'PACTOS: '
                              : 'CALCULADORA ELECTORAL: '}
                            <span className="featured">
                              {selectedType === TYPES.REGIONAL
                                ? 'Autonomías'
                                : 'Municipios'}
                            </span>
                          </h2>
                          <div className="buttonsContainer">
                            <Button
                              className={
                                selectedType === TYPES.REGIONAL ? 'current' : ''
                              }
                              onClick={() => changeScope(TYPES.REGIONAL)}
                            >
                              Autonómicas
                            </Button>
                            <Button
                              className={
                                selectedType === TYPES.MUNICIPAL
                                  ? 'current'
                                  : ''
                              }
                              onClick={() => changeScope(TYPES.MUNICIPAL)}
                            >
                              Municipales
                            </Button>
                          </div>
                        </div>
                        <div className="cityToggleWrapper">
                          <div className="cityTitleWrapper">
                            <h3 className="cityTitle">{selectedPlace.name}</h3>
                          </div>
                          <div className="autocompleteWrapper">
                            <div className="cityToggle">
                              <PlacesProvider
                                type={
                                  selectedType === TYPES.REGIONAL
                                    ? 'REGION'
                                    : ''
                                }
                                name={autocomple}
                                parentId={
                                  selectedType === TYPES.REGIONAL
                                    ? 'C108'
                                    : null
                                }
                                excludedGrandParentIds={
                                  selectedType === TYPES.REGIONAL
                                    ? EXCLUDED_REGIONS
                                    : []
                                }
                                includedIds={
                                  selectedType === TYPES.MUNICIPAL
                                    ? [
                                        '28079',
                                        '08019',
                                        '15078',
                                        '48020',
                                        '50297',
                                        '46250',
                                        '41091',
                                        '36057',
                                        '29067',
                                        '11012'
                                      ]
                                    : []
                                }
                              >
                                {data => {
                                  return (
                                    <Autocomplete
                                      results={data}
                                      onChange={value => setAutocomple(value)}
                                      onSelect={value => changeSelection(value)}
                                      placeholder={
                                        selectedType === TYPES.REGIONAL
                                          ? 'Selecciona una comunidad'
                                          : 'Selecciona un municipio'
                                      }
                                      showArrow
                                    />
                                  );
                                }}
                              </PlacesProvider>
                            </div>
                          </div>
                        </div>
                        <div className="multiPactometroWrapper">
                          <div className="pactometroWrapper">
                            <PactometroCheck
                              selecteds={selectedChecks}
                              totalSeat={dataResult.totalSeats}
                              seatData={
                                dataResult && dataResult.partiesResult
                                  ? dataResult.partiesResult
                                  : []
                              }
                              type={dataResult.type}
                            />
                          </div>
                        </div>
                      </Fragment>
                    </div>
                  )}
                </ResultProvider>
              </Fragment>
            )}
          </ResultProvider>
        </Fragment>
      )}
    </div>
  );
};

export default MultiPactometroA3;
